import { Link } from 'react-router-dom';

import { Box, theme } from '@sbv-clients/ui-shared';

export const BackToSignIn = () => (
  <Box sx={{ display: 'flex', justifyContent: 'center', mt: '16px' }}>
    <Box
      component={Link}
      to="/auth/sign-in"
      sx={{
        display: 'inline-flex',
        alignItems: 'center',
        gap: '4px',
        fontSize: '13px',
        fontWeight: 500,
        color: `${theme.colors.primary.main} !important`,
        '&:hover': { textDecoration: 'underline !important' },
      }}
    >
      <Box
        component="svg"
        viewBox="0 0 24 24"
        aria-hidden
        sx={{
          width: 14,
          height: 14,
          fill: 'none',
          stroke: 'currentColor',
          strokeWidth: 1.8,
          strokeLinecap: 'round',
          strokeLinejoin: 'round',
        }}
      >
        <path d="M19 12H5m5-5-5 5 5 5" />
      </Box>
      Back to sign in
    </Box>
  </Box>
);
